import { trpc } from "../../main/components/trpc.ts";
import { formaters } from "vincent-utils";
import { skipToken } from "@tanstack/react-query";
import _ from "underts";
import { FaLongArrowAltLeft, FaLongArrowAltRight } from "react-icons/fa";
import { useState } from "react";
import { DateTime } from "luxon";
import PatientsStateManager from "./PatientsStateManager";
import { DDNSchema, E164Schema } from "cadendar-shared";

const PatientsDuJour = () => {
  const today = formaters.filterDateTimeForPureDate(new Date());
  const [dateSelected, setDateSelected] = useState(today);
  const onSetPrevDay = () => {
    setDateSelected(
      DateTime.fromJSDate(dateSelected).minus({ days: 1 }).toJSDate()
    );
  };
  const onSetNextDay = () => {
    setDateSelected(
      DateTime.fromJSDate(dateSelected).plus({ days: 1 }).toJSDate()
    );
  };
  const onSetToday = () => {
    setDateSelected(today);
  };
  const dateInputValue = DateTime.fromJSDate(dateSelected).toISODate() || "";
  const onSetDate = (value: string) => {
    const date = DateTime.fromISO(value);
    if (date.isValid) {
      setDateSelected(date.startOf("day").toJSDate());
    }
  };
  const patients =
    trpc.patient.findByRdvDate.useQuery({ date: dateSelected }).data || [];
  const patientIds = patients.map((p) => p.id);
  const isNonEmpty = _.isNonEmpty(patientIds);
  const patientStates =
    trpc.patient.getStatesByIds.useQuery(isNonEmpty ? patientIds : skipToken)
      .data || [];

  const nextRdvs =
    trpc.rdv.getNextRdvsByPatientIds.useQuery(
      isNonEmpty ? { patientIds } : skipToken
    ).data || {};

  const patientsWithStates = patients.map((patient) => {
    const state = patientStates.find((s) => s.patient_id === patient.id);
    const next_rdv = nextRdvs ? nextRdvs[patient.id] || null : null;
    return {
      ...patient,
      portablee164: E164Schema.safeParse(patient.portablee164).success
        ? E164Schema.parse(patient.portablee164)
        : null,
      birthdate: DDNSchema.parse(patient.birthdate),
      state: state
        ? state.state
          ? state.state
          : ("toClassify" as const)
        : ("toClassify" as const),
      quote_state: state ? state.quote_state : null,
      pec_state: state ? state.pec_state : null,
      comment: state ? state.comment : "",
      stateId: state ? state.id : null,
      updated_at: state ? state.updated_at : null,
      next_rdv,
    };
  });
  return (
    <div className="flex justify-center flex-col">
      <div className="flex items-center justify-center gap-1 cursor-pointer text-lg">
        <FaLongArrowAltLeft
          size="1.4rem"
          className="hover:text-blue-500"
          onClick={onSetPrevDay}
        />
        <div
          className="w-80 max-w-[calc(100vw-3rem)] shrink-0 text-center hover:text-blue-500 select-none"
          onClick={onSetToday}
        >
          Patients du {formaters.formatDateForDisplayWithDay(dateSelected)}
        </div>
        <FaLongArrowAltRight
          size="1.4rem"
          className="hover:text-blue-500"
          onClick={onSetNextDay}
        />
        <input
          type="date"
          aria-label="Choisir un jour"
          value={dateInputValue}
          onChange={(event) => onSetDate(event.currentTarget.value)}
          className="ml-2 rounded border border-gray-300 bg-white px-2 py-1 text-sm"
        />
      </div>
      <PatientsStateManager patients={patientsWithStates} sortType="today" />
    </div>
  );
};

export default PatientsDuJour;
